import React from 'react';
import Joi from 'joi';

import InspectionStandard from '../../themed/inspection-standard';
import Form from '../../common/form';
import VICustomCoverItemForm from './viCustomCoverItemForm';

import withRouter from '../../hoc/withRouter';

import { SelectOption } from '../../../utils/models';
import { matchPhrases } from '../../../utils/utilities';

import { error } from '../../../services/toastService';
import { getReportCacheProgress } from '../../../services/reportCache';

import logger from '../../../services/logService';

class VICustomCoverForm extends Form {
	state = {
		data: { scopeOfWork: '', coverData: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		scopeOfWork: Joi.string().min(5).required().label('Scope Of Work'),
		coverData: Joi.array()
			.min(1)
			.items(
				Joi.object({
					count: Joi.number().required().label('Count'),
					id: Joi.string().required().label('Inspection Standard Label'),
					name: Joi.string()
						.min(3)
						.required()
						.label('Inspection Standard Value'),
				})
			)
			.required()
			.label('Cover Data'),
	};

	async componentDidMount() {
		try {
			const projectId: string = this.props.params.projectId;
			const { data: cachedReport } = await getReportCacheProgress(projectId);
			if (cachedReport) this.setState({ data: cachedReport.value.viCoverData });
		} catch (error) {
			logger.log(error as Error);
		}
	}

	handleAddCoverItem = (coverItem: SelectOption) => {
		const allCoverItems: SelectOption[] = this.state.data.coverData;
		const coverItemMatch = allCoverItems.find((item) => matchPhrases(item.id.toString(), coverItem.id.toString()));
		if (coverItemMatch) return error('This inspection standard has already been added!');

		const newCoverItem: SelectOption = { id: coverItem.id, name: coverItem.name };
		this.setState({ data: { ...this.state.data, coverData: [...allCoverItems, newCoverItem] } });
	};

	handleRemoveCoverItem = (coverItem: SelectOption) => {
		const newCoverData = this.state.data.coverData.filter((item: SelectOption) => item.id !== coverItem.id);
		this.setState({ data: { ...this.state.data, coverData: newCoverData } });
	};

	doSubmit = () => {
		this.props.onAddCoverForm(this.state.data);
	};

	render() {
		return (
			<React.Fragment>
				<div className="my-4 divider"></div>

				<VICustomCoverItemForm onAddCoverItem={this.handleAddCoverItem} />

				{this.state.data.coverData.map((item: SelectOption) => (
					<InspectionStandard
						key={item.id}
						title={item.id.toString()}
						body={item.name.toString()}
						onRemove={() => this.handleRemoveCoverItem(item)}
					/>
				))}

				<div className="my-4 divider"></div>

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					<p className="form-title">Reference Documents / Work Instruction</p>

					<div className="my-4 divider"></div>

					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'scopeOfWork',
								label: 'Scope of work',
								placeholder: 'Enter Scope of Work',
							})}
						</div>
					</div>

					<div className="my-4 divider"></div>

					<div className="d-flex justify-content-end">
						{this.renderButton('Save Cover Sheet Data')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default withRouter(VICustomCoverForm);
